import { Column } from "../objects/column";
import { CommercialInformation } from "../objects/commercialInformation";
import { CommercialInformationErrors } from "../objects/commercialInformationErrors";
import { CommercialInformationListConfiguration } from "../objects/commercialInformationListConfiguration";
import { CommercialInformationListCriteria } from "../objects/commercialInformationListCriteria";
import { CommercialInformationListFiltersCriteria } from "../objects/commercialInformationListFiltersCriteria";


export const COMMERCIAL_INFORMATION_MODULE = 'COMMERCIAL_INFORMATION';
export const COMMERCIAL_INFORMATION_INFO_ROUTE = '/central-payment/edit/:id/info';

export const EMPTY_COMMERCIAL_INFORMATION: CommercialInformation = {
    name: "",
    street: "",
    zip_code: "",
    country: null,
    city: "",
    id: -1,
    last_author: null,
    modified_date: null,
    creator: null,
    created_date: null
};

export const EMPTY_COMMERCIAL_INFORMATION_ERRORS: CommercialInformationErrors = {
    name_error: ""
};


export const EMPTY_COMMERCIAL_INFORMATION_FILTERS: CommercialInformationListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_COMMERCIAL_INFORMATION_LIST_CRITERIA: CommercialInformationListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_COMMERCIAL_INFORMATION_FILTERS,
    search: ''
};

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'address',
    field_name: 'ADDRESS',
    checked: false,
    order_by: 'address',
    fixed_width: false,
    last_updated: false
}, {
    label: 'zip-code',
    field_name: 'ZIP_CODE',
    checked: false,
    order_by: 'zip_code',
    fixed_width: false,
    last_updated: false
}, {
    label: 'city',
    field_name: 'CITY',
    checked: true,
    order_by: 'city',
    fixed_width: false,
    last_updated: false
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: false,
    order_by: 'country',
    fixed_width: false,
    last_updated: false
}];

export const EMPTY_COMMERCIAL_INFORMATION_LIST_CONFIGURATION: CommercialInformationListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};
